// extracted by mini-css-extract-plugin
export default {"error":"SignUnsignedChanges_error__MBCUH","active":"SignUnsignedChanges_active__tfLRH","button":"SignUnsignedChanges_button__g6kka"};